import {
  AUTO_CONFIRMABLE_KINDS,
  AUTO_EXECUTE_KINDS,
  DESTRUCTIVE_KINDS,
  MODIFY_KINDS,
  SERVER_EXECUTED_KINDS,
  type SofiaActionKind,
} from "../model/constants"

/** Drive mode may auto-confirm only kinds explicitly allowlisted as safe. */
export function isAutoConfirmable(kind: SofiaActionKind): boolean {
  return AUTO_CONFIRMABLE_KINDS.includes(kind)
}

/**
 * Kinds that EXECUTE on arrival with no confirm card and no countdown, even
 * when drive mode is off — currently only `navigate` (non-destructive, browser-
 * back reversible). The panel must skip the proposed/armed card state for these
 * and render a compact one-line receipt instead.
 */
export function isAutoExecute(kind: SofiaActionKind): boolean {
  return AUTO_EXECUTE_KINDS.includes(kind)
}

/**
 * Kinds executed server-side via the public /v1 API (the signed confirmation
 * echo) rather than client-side transport. The panel routes a confirmed
 * proposal of one of these kinds back through the chat proxy as a signed
 * `ActionConfirmation` instead of firing a transport mutation.
 */
export function isServerExecuted(kind: SofiaActionKind): boolean {
  return SERVER_EXECUTED_KINDS.includes(kind)
}

/**
 * Modify kinds (`update_*`): change an existing resource. The card renders a
 * "what changes" treatment (rationale + new values) and ALWAYS requires a manual
 * confirm — they are never auto-confirmable, so drive mode can't run them.
 */
export function isModify(kind: SofiaActionKind): boolean {
  return MODIFY_KINDS.includes(kind)
}

/**
 * Destructive kinds (`delete_*`): permanently remove a resource. The card
 * renders danger styling + a can't-be-undone warning and ALWAYS requires a
 * manual confirm — they are never auto-confirmable, so drive mode can't run them.
 */
export function isDestructive(kind: SofiaActionKind): boolean {
  return DESTRUCTIVE_KINDS.includes(kind)
}
